import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getBranchEnvironment } from '@app/redux/branchEnvironment/branchEnvironment.selectors';
import { useAppSelector } from '@app/redux/hooks';

function useEnforceQueryParams() {
	const branchEnvironment = useAppSelector(getBranchEnvironment);
	const location = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (branchEnvironment.is_branch_from_query_params) {
			const searchParams = new URLSearchParams(location.search);
			if (!searchParams.has('branch_id') || !searchParams.has('rep_id') || !searchParams.has('auth_form_slug')) {
				searchParams.set('branch_id', String(branchEnvironment.branch_id));
				searchParams.set('rep_id', String(branchEnvironment.rep_id));
				searchParams.set('auth_form_slug', branchEnvironment.auth_form_slug);
				history.replace({ pathname: location.pathname, search: searchParams.toString(), state: location.state });
			}
		}
	}, [location, history, branchEnvironment]);
}

export default useEnforceQueryParams;
